import { Outlet, useLocation } from "react-router-dom";
import React, { useEffect } from "react";

import Menu from "./SideMenu";
import authService from "@src/api/authService";
import { css } from "@emotion/react";
import { firstPage } from "@src/constants/Menu";
import { useNavigate } from "react-router-dom";

function Layout() {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const isLogin = authService.isUserLogin();

    useEffect(() => {
        if (!isLogin) {
            navigate(firstPage);
        }
    });

    return (
        <div
            css={
                pathname.includes("/coupon/detail")
                    ? rootNoMenuStyle
                    : rootStyle
            }
        >
            <Menu />
            <Outlet />
        </div>
    );
}

const rootStyle = css`
    display: flex;
    padding-left: 235px;
    @media (max-width: 768px) {
        padding-left: 0;
    }
`;

const rootNoMenuStyle = css`
    display: flex;
    padding-left: 0;
`;

export default Layout;
